<template>
  <Navbar />
  <div class="content-wrapper " :class="activePromotion? 'mt-4' : 'mt-40'">
    <div class="main-content">
      <div v-if="isLoading">
        <Loader />
      </div>

      <section class="overflow-hidden">
        <div v-if="!isLoading">
          <Heading :isMenuVisible="isMenuVisible" />

          <CourseInfo />
          <div class="pt-60">
            <RecentCourses :latestCourses="latestCourses" ref="targetSection" />
          </div>
        </div>
      </section>
    </div>
    <FooterItem />
  </div>
</template>

<script>
import Navbar from "@/components/Layout/Navbar.vue";
import Heading from "@/components/CourseDetails/Heading.vue";
import CourseInfo from "@/components/CourseDetails/CourseInfo.vue";
import FooterItem from "@/components/Layout/FooterItem.vue";
import Loader from "@/components/common/Loader.vue";
import { useHead } from "@vueuse/head";
import { mapGetters } from "vuex";
import store from "@/store";
import RecentCourses from "@/components/Homepage/RecentCourses.vue";
import { getLatestCourses } from "@/Services/api/CoursesService";
export default {
  components: {
    Navbar,
    Heading,
    CourseInfo,
    FooterItem,
    RecentCourses,
    Loader,
  },
  data() {
    return {
      targetOffsetTop: 0,
      isMenuVisible: false,
      latestCourses: []
    };
  },
  computed: {
    ...mapGetters(["currentLanguage", "isLoading", "error"]),
    courseId() {
      return this.$route.params.id;
    },
    error() {
      return this.$store.getters['error'];
    },
    combinedCourseWatcher() {
      return {
        language: this.currentLanguage,
        id: this.courseId,
      };
    },
  },
  watch: {
    combinedCourseWatcher: {
      handler(newval, oldval) {
        store.dispatch('fetchCourseDetails', newval.id);
        this.updateHeadMeta();
        store.dispatch("categoriesList");
        this.getRecentCourse()
      },
      immediate: true, // Run the handler immediately when the component is mounted
    },
    error(newVal) {
      if (newVal) {
        this.redirectToErrorPage();
      }
    },
  },
  mounted() {
     // store.dispatch('fetchUserData');
    if (!this.isLoading) {
      this.initializeObserver();
    }

    // setTimeout(() => {
    //   if (!this.isLoading) {
    //     this.initializeObserver();
    //   }
    // }, 2000);

    this.updateHeadMeta(
      "Advanced Web Development",
      "Learn advanced techniques in web development, including HTML5, CSS3, JavaScript, and modern frameworks like React.",
      "https://example.com/images/web-development-course.jpg",
      "https://example.com/courses/advanced-web-development"
    );
  },
  beforeDestroy() {
    // Clean up the observer
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    redirectToErrorPage() {
      this.$router.replace({ name: 'error' });
    },

    //recent courses
    async getRecentCourse() {
      try {
        const response = await getLatestCourses();
        this.latestCourses = response.data;
      } catch (error) {
        console.log(error.message)
      }
    },

    initializeObserver() {
      const targetSection = this.$refs.targetSection.$el;

      // Set up the IntersectionObserver
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // If the first pixel of the component is visible, hide the menu
              this.isMenuVisible = false;
            } else {
              // If the component is no longer in view, show the menu again
              this.isMenuVisible = true;
            }
          });
        },
        {
          threshold: 0, // Trigger when any part of the element is in view
        }
      );
      // Start observing the target element
      this.observer.observe(targetSection);
    },
    updateHeadMeta(courseTitle, courseDescription, courseImageUrl, courseUrl) {
      const title =
        this.currentLanguage === "ar"
          ? `${courseTitle} - تفاصيل الدورة | Planning Force`
          : `${courseTitle} - Course Details | Planning Force`;

      const description =
        this.currentLanguage === "ar"
          ? courseDescription ||
          "تعرف على هذه الدورة التدريبية الشاملة وتفاصيلها حول الأهداف، المحتوى، المدة، والمدربين."
          : courseDescription ||
          "Learn more about this comprehensive course, including objectives, content, duration, and instructors.";

      const keywords =
        this.currentLanguage === "ar"
          ? `الدورة, ${courseTitle}, تعليم إلكتروني, تطوير المهارات, Planning Force`
          : `course, ${courseTitle}, e-learning, skill development, Planning Force`;

      useHead({
        title: title,
        meta: [
          { name: "description", content: description },
          { name: "keywords", content: keywords },
          { name: "robots", content: "index, follow" },
          {
            name: "author",
            content:
              this.currentLanguage === "ar"
                ? "معهد Planning Force العالي للتدريب"
                : "Planning Force High Institute for Training",
          },
          {
            name: "language",
            content: this.currentLanguage === "ar" ? "ar" : "en",
          },

          // Open Graph meta tags
          { property: "og:title", content: title },
          { property: "og:description", content: description },
          {
            property: "og:image",
            content:
              courseImageUrl || "https://example.com/default-course-image.jpg",
          }, // Replace with your default image if no URL is provided
          {
            property: "og:url",
            content: courseUrl || "https://example.com/courses/details",
          }, // Replace with your course details page URL
          { property: "og:type", content: "website" },

          // Twitter Card meta tags
          { name: "twitter:card", content: "summary_large_image" },
          { name: "twitter:title", content: title },
          { name: "twitter:description", content: description },
          {
            name: "twitter:image",
            content:
              courseImageUrl || "https://example.com/default-course-image.jpg",
          }, // Replace with your default image if no URL is provided
        ],
      });
    },
  },
};
</script>
